
<!--------------------------------------View 271-------------------------------------------------->
<div class="row">
    <div class="col-lg-12">
      <div style="width:730px ;padding-left:15px">
        <div>271 Report</div>
        <div *ngIf="viewFiles271">
          <ng-container *ngFor="let edi271 of edi271list">
            <div class="row">
              <div class="col-lg-3">FileName</div>
              <div class="col-lg-9">: {{edi271.fileName}}</div>
            </div>
            <div class="row">
              <div class="col-lg-3">Imported Date</div>
              <div class="col-lg-9">: {{edi271.importedDate|date:'MM/dd/yyyy'}}</div>
            </div>
            <div class="row">
              <div class="col-lg-3">Unique ISA Id</div>
              <div class="col-lg-9">: {{edi271.unique271ISA}}</div>
            </div>
            <div class="row">
              <div class="col-lg-3">Interchange Date</div>
              <div class="col-lg-9">: {{edi271.interchangeDateTime|date:'MM/dd/yyyy'}}</div>
            </div>

            <div class="Sender">
              <h2>Sender</h2>
              <div *ngIf="edi271.sender_EntityIdentifier!=null && edi271.sender_EntityIdentifier!=''" class="row">
                <div class="col-lg-3">Entity</div>
                <div class="col-lg-9">: {{edi271.sender_EntityIdentifier}}</div>
              </div>
              <div *ngIf="edi271.sender_Name!=null && edi271.sender_Name!=''" class="row">
                <div class="col-lg-3">Name</div>
                <div class="col-lg-9">: {{edi271.sender_Name}}</div>
              </div>
              <div *ngIf="edi271.sender_Id!= null && edi271.sender_Id!=''" class="row">
                <div class="col-lg-3">ID</div>
                <div class="col-lg-9">: {{edi271.sender_Id}} <br> ({{edi271.sender_IdQualifier}})</div>
              </div>
              <h6
                *ngIf="edi271.sender_CommunicationNumberQualifier1!=null && edi271.sender_CommunicationNumberQualifier1!=''">
                Contact</h6>
              <div>{{edi271.sender_ContactName}}</div>
              <div class="row" *ngIf="edi271.sender_CommunicationNumber1!=null && edi271.sender_CommunicationNumber1!=''">
                <div 
                  class="col-lg-3">{{edi271.sender_CommunicationNumberQualifier1}}</div>
                <div class="col-lg-9">: {{edi271.sender_CommunicationNumber1}}</div>
              </div>
              <div *ngIf="edi271.sender_CommunicationNumber2!=null && edi271.sender_CommunicationNumber2!=''"
                class="row">
                <div class="col-lg-3">{{edi271.sender_CommunicationNumberQualifier2}}</div>
                <div class="col-lg-9">: {{edi271.sender_CommunicationNumber2}}</div>
              </div>
              <div *ngIf="edi271.sender_CommunicationNumber3!=null && edi271.sender_CommunicationNumber3!=''"
                class="row">
                <div class="col-lg-3">{{edi271.sender_CommunicationNumberQualifier3}}</div>
                <div class="col-lg-9">: {{edi271.sender_CommunicationNumber3}}</div>
              </div>
            </div>

            <div class="Receiver">
              <h2>Receiver</h2>
              <div *ngIf="edi271.receiver_EntityIdentifier!=null && edi271.receiver_EntityIdentifier!=''"
                class="row">
                <div class="col-lg-3">Entity</div>
                <div class="col-lg-9">: {{edi271.receiver_EntityIdentifier}}</div>
              </div>
              <div *ngIf="edi271.receiver_Name!=null && edi271.receiver_Name!=''" class="row">
                <div class="col-lg-3">Name</div>
                <div class="col-lg-9">: {{edi271.receiver_Name}}</div>
              </div>
              <div *ngIf="edi271.receiver_Id!=null && edi271.receiver_Id!=''" class="row">
                <div class="col-lg-3">ID</div>
                <div class="col-lg-9">: {{edi271.receiver_Id}} <br> ({{edi271.receiver_IdQualifier}})</div>
              </div>
              <div
                *ngIf="edi271.receiver_AddressLine1 != null || edi271.receiver_AddressLine1!='' || edi271.receiver_City!=null || edi271.receiver_City !=''"
                class="row">
                <div class="col-lg-3">Address</div>
                <div class="col-lg-9">: {{edi271.receiver_AddressLine1}} <br
                    *ngIf="edi271.receiver_AddressLine2 != null">

                  {{edi271.receiver_AddressLine2}} <br> {{edi271.receiver_City}} <br>
                  {{edi271.receiver_StateCode}}
                  <br> {{edi271.receiver_ZipCode}}
                </div>
              </div>
            </div>

            <ng-container *ngFor="let client of edi271?.clients">
              <div class="Client">
                <h3>Subscriber</h3>
                <div class="ClientBasicDetails">
                  <div *ngIf="client.clientName!=null && client.clientName!=''" class="row">
                    <div class="col-lg-3">Name</div>
                    <div class="col-lg-9">: {{client.clientName}}</div>
                  </div>
                  <div *ngIf="client.clientID!=null && client.clientID!=''" class="row">
                    <div class="col-lg-3">ID</div>
                    <div class="col-lg-9">: {{client.clientID}} <br> ({{client.clientIdQualifier}})</div>
                  </div>
                  <div
                    *ngIf="edi271.receiver_AddressLine1 != null || edi271.receiver_AddressLine1!='' || edi271.receiver_City!=null || edi271.receiver_City !=''"
                    class="row">
                    <div class="col-lg-3">Address</div>
                    <div class="col-lg-9">: {{client.addressLine1}} <br *ngIf="client.addressLine2 != null">
                      {{client.addressLine2}} <br> {{client.city}} <br> {{client.state}} <br> {{client.zipCode}}
                    </div>
                  </div>
                  <div *ngIf="client.dOB!=null && client.dOB!=''" class="row">
                    <div class="col-lg-3">DOB</div>
                    <div class="col-lg-9">: {{client.dOB|date:'MM/dd/yyyy'}}</div>
                  </div>
                  <div *ngIf="client.gender!=null && client.gender!=''" class="row">
                    <div class="col-lg-3">Gender</div>
                    <div class="col-lg-9">: {{client.gender}}</div>
                  </div>
                </div>
                <div class="AAADetails" *ngIf="client.aaaDetails!=null && client.aaaDetails!=''">
                  <h5>Subscriber Validation</h5>
                  <ng-container *ngFor="let aaa of client?.aaaDetails">
                    <div *ngIf="aaa.validRequest!=null && aaa.validRequest!=''" class="row">
                      <div class="col-lg-3">Valid ReQuest</div>
                      <div class="col-lg-9">: {{aaa.validRequest}}</div>
                    </div>
                    <div *ngIf="aaa.agencyQualifier!=null && aaa.agencyQualifier!=''" class="row">
                      <div class="col-lg-3">Agency Qualifier</div>
                      <div class="col-lg-9">: {{aaa.agencyQualifier}}</div>
                    </div>
                    <div *ngIf="aaa.rejectReason!=null && aaa.rejectReason!=''" class="row">
                      <div class="col-lg-3">Reason For Rejection</div>
                      <div class="col-lg-9">: {{aaa.rejectReason}}</div>
                    </div>
                    <div *ngIf="aaa.followupAction!=null && aaa.followupAction!=''" class="row">
                      <div class="col-lg-3">Follow-Up Action</div>
                      <div class="col-lg-9">: {{aaa.followupAction}}</div>
                    </div>
                  </ng-container>
                </div>
                <div class="LoopDetails">
                  <ng-container *ngFor="let loop of client?.loopDetails">
                    <div class="EBandMessage">
                      <h5>Eligibility and Benefit Info</h5>
                      <div
                        *ngIf="loop.eligibilityorBenefitInformation!=null && loop.eligibilityorBenefitInformation!=''"
                        class="row">
                        <div class="col-lg-3">Eligibility or Beneefit Information</div>
                        <div class="col-lg-9">: {{loop.eligibilityorBenefitInformation}}</div>
                      </div>
                      <div *ngIf="loop.benefitCoverageLevel!=null && loop.benefitCoverageLevel!=''" class="row">
                        <div class="col-lg-3">Coverage Level</div>
                        <div class="col-lg-9">: {{loop.benefitCoverageLevel}}</div>
                      </div>
                      <div *ngIf="loop.serviceType!=null && loop.serviceType!=''" class="row">
                        <div class="col-lg-3">Service Covered</div>
                        <div class="col-lg-9">: {{loop.serviceType}}</div>
                      </div>
                      <div *ngIf="loop.insuranceType!=null && loop.insuranceType!=''" class="row">
                        <div class="col-lg-3">Insurance Type</div>
                        <div class="col-lg-9">: {{loop.insuranceType}}</div>
                      </div>
                      <div *ngIf="loop.planCoverageDescription!=null && loop.planCoverageDescription!=''"
                        class="row">
                        <div class="col-lg-3">Plan Coverage Description</div>
                        <div class="col-lg-9">: {{loop.planCoverageDescription}}</div>
                      </div>
                      <div *ngIf="loop.timePeriodQualifier!=null && loop.timePeriodQualifier!=''" class="row">
                        <div class="col-lg-3">Time Period</div>
                        <div class="col-lg-9">: {{loop.timePeriodQualifier}}</div>
                      </div>
                      <div *ngIf="loop.benefitAmount!=null && loop.benefitAmount!=''" class="row">
                        <div class="col-lg-3">Benefit Amount</div>
                        <div class="col-lg-9">: {{loop.benefitAmount}}</div>
                      </div>
                      <div *ngIf="loop.benefitPercent!=null && loop.benefitPercent!=''" class="row">
                        <div class="col-lg-3">Benefit Percentage</div>
                        <div class="col-lg-9">: {{loop.benefitPercent}}</div>
                      </div>
                      <div *ngIf="loop.quantityQualifier!=null && loop.quantityQualifier!=''" class="row">
                        <div class="col-lg-3">Quantity Qualifier</div>
                        <div class="col-lg-9">: {{loop.quantityQualifier}}</div>
                      </div>
                      <div *ngIf="loop.authorizationorCertificationIndicator!=null && loop.benefitQuantity!=''"
                        class="row">
                        <div class="col-lg-3">Benefit Quantity</div>
                        <div class="col-lg-9">: {{loop.benefitQuantity}}</div>
                      </div>
                      <div
                        *ngIf="loop.authorizationorCertificationIndicator!=null && loop.authorizationorCertificationIndicator!=''"
                        class="row">
                        <div class="col-lg-3">Authorization Certification</div>
                        <div class="col-lg-9">: {{loop.authorizationorCertificationIndicator}}</div>
                      </div>
                      <div *ngIf="loop.inPlanNetwork!=null && loop.inPlanNetwork!=''" class="row">
                        <div class="col-lg-3">InPlan Network</div>
                        <div class="col-lg-9">: {{loop.inPlanNetwork}}</div>
                      </div>
                      <div
                        *ngIf="loop.cmP_ProductorServiceIDQualifier!=null && loop.cmP_ProductorServiceIDQualifier!=''"
                        class="row">
                        <h6>Composite Medical Procedure</h6>
                        <div class="col-lg-3">Product or Service ID Qualifier</div>
                        <div class="col-lg-9">: {{loop.cmP_ProductorServiceIDQualifier}}</div>
                      </div>
                      <div *ngIf="loop.cmP_ProductServiceID!=null && loop.cmP_ProductServiceID!=''" class="row">
                        <div class="col-lg-3">Product Service ID</div>
                        <div class="col-lg-9">: {{loop.cmP_ProductServiceID}}</div>
                      </div>
                      <div *ngIf="loop.cmP_ProcedureCode!=null && loop.cmP_ProcedureCode!=''" class="row">
                        <div class="col-lg-3">Procedure Code</div>
                        <div class="col-lg-9">: {{loop.cmP_ProcedureCode}}</div>
                      </div>
                      <div *ngIf="loop.cmP_ProcedureModifiers!=null && loop.cmP_ProcedureModifiers!=''"
                        class="row">
                        <div class="col-lg-3">Procedure Modifiers</div>
                        <div class="col-lg-9">: {{loop.cmP_ProcedureModifiers}}</div>
                      </div>
                      <div *ngIf="loop.cmP_Description!=null && loop.cmP_Description!=''" class="row">
                        <div class="col-lg-3">Description</div>
                        <div class="col-lg-9">: {{loop.cmP_Description}}</div>
                      </div>
                      <div *ngIf="loop.diagnosisCodePointers!=null && loop.diagnosisCodePointers!=''" class="row">
                        <div class="col-lg-3">Diagnosis Code Pointer</div>
                        <div class="col-lg-9">: {{loop.diagnosisCodePointers}}</div>
                      </div>
                      <div *ngIf="loop.messages!=null && loop.messages!=''" class="row">
                        <div class="col-lg-3">Messages</div>
                        <div class="col-lg-9">: {{loop.messages}}</div>
                      </div>
                    </div>
                    <div class="DTPDetails">
                      <ng-container *ngFor="let dtp of loop?.dtpDetails">
                        <div *ngIf="dtp.dateTimeQualifier!=null && dtp.dateTimeQualifier!=''" class="row">
                          <div class="col-lg-3">{{dtp.dateTimeQualifier}}</div>
                          <div class="col-lg-9">: {{dtp.dateTimePeriod|date:'MM/dd/yyyy'}}</div>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
            <br />
            <hr />
            <br />
          </ng-container>
        </div>

      </div>

    </div>
  </div>



